var $03e73e050e75c075$exports = {};
$03e73e050e75c075$exports = {
    "decrease": (args)=>`Riduci ${args.fieldLabel}`,
    "increase": (args)=>`Aumenta ${args.fieldLabel}`,
    "numberField": `Campo numero`
};


export {$03e73e050e75c075$exports as default};
//# sourceMappingURL=it-IT.mjs.map
